module.exports = __webpack_public_path__ + "img/vi-home-bg.3a5cc6d9.png";